interface MapSelectionGlobeViewsStore {
  clearList(): void
}

interface MapSelectionConfigurationsState {
  resetToDefaultWorkflowsConfigurations(): void
  resetToDefaultLogisticsConfigurations(): void
  resetToDefaultDeliveryConfigurations(): void
}

// The first-configured-map pick resolves against the globes, the sitemaps and each
// app configuration; left "received" from the previous project it resolves against
// stale data.
export function resetMapSelectionInputs(
  globeViewsStore: MapSelectionGlobeViewsStore,
  state: MapSelectionConfigurationsState,
): void {
  globeViewsStore.clearList()
  state.resetToDefaultWorkflowsConfigurations()
  state.resetToDefaultLogisticsConfigurations()
  state.resetToDefaultDeliveryConfigurations()
}
